import { Accordion, AccordionDetails, Grid } from '@mui/material'

import useStyles from '../index.styles'

import AccordionGroup from './accordion-group'
import AccordionGroupExtraSensors, { EXTRA_SENSORS_GROUP_KEY } from './accordion-group-extra-sensors'
import DeviceItem from './device-item'

export interface IAttentionGroup {
  label: string
  key: string
  devices: IDeviceType[]
}

const AccordionGroupAttention = ({
  groups,
  expandedGroup,
  onToggle,
  showActivateButton,
  onActivate,
}: {
  groups: IAttentionGroup[]
  expandedGroup: string | false
  onToggle: (key: string) => (event: React.SyntheticEvent, newExpanded: boolean) => void
  showActivateButton: boolean
  onActivate: () => void
}) => {
  const classes = useStyles

  return (
    <>
      {groups
        .filter((group) => group.devices.length > 0)
        .map((group) => {
          if (group.key === EXTRA_SENSORS_GROUP_KEY) {
            return (
              <AccordionGroupExtraSensors
                key={group.key}
                devices={group.devices}
                isExpanded={expandedGroup === group.key}
                onToggle={onToggle}
                showActivateButton={showActivateButton}
                onActivate={onActivate}
              />
            )
          }

          return (
            <Accordion
              key={group.key}
              data-testid="attention-accordion"
              expanded={expandedGroup === group.key}
              onChange={onToggle(group.key)}
              sx={[classes.accordion, classes.firstLevelAccordion]}
            >
              <AccordionGroup.SummaryTopLevel label={group.label} count={group.devices.length} hasAlert={group.key === 'alerting'} showPlaceIcon={false} />
              <AccordionDetails sx={classes.accordionDetails}>
                <Grid container={true} size={12} columnSpacing={1} rowSpacing={1} sx={classes.accordionDeviceContainer}>
                  {group.devices.map((device) => (
                    <DeviceItem key={device.node.id} device={device} />
                  ))}
                </Grid>
              </AccordionDetails>
            </Accordion>
          )
        })}
    </>
  )
}

export default AccordionGroupAttention
